var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-features"},[_c('landing-container',{staticClass:"landing-features__container"},_vm._l((_vm.cards),function(card,i){return _c('feature-card',{key:i,attrs:{"card-text":card.text,"image":card.image}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }